import { Link } from "react-router-dom";
import NavAiBadge from "./shared/NavAiBadge";
import { SIDEBAR_DISABLED_REASON } from "./sidebarNavConfig";
import { trackCtaClicked } from "../analytics/analytics";

function DisabledNavItem({ nav }) {
    const isComingSoon = nav.disabledReason === SIDEBAR_DISABLED_REASON.COMING_SOON;

    return (
        <div
            className="flex cursor-not-allowed items-center px-3 py-3 opacity-70 select-none"
            aria-disabled="true"
            title={nav.disabledTitle ?? "Unavailable"}
        >
            <i className={`${nav.icon} me-2 text-slate-400`} aria-hidden />
            <span className="text-xs font-medium tracking-wide text-slate-400">{nav.name}</span>
            {nav.aiBadge ? <NavAiBadge /> : null}
            {isComingSoon ? (
                <span className="ms-auto shrink-0 rounded-md border border-slate-200/60 bg-slate-100/50 px-1.5 py-0.5 text-[9px] font-semibold uppercase tracking-wide text-slate-500 backdrop-blur-sm">
                    Coming soon
                </span>
            ) : null}
        </div>
    );
}

function NavItem({ nav, isActive, onItemClick }) {
    if (nav.disabled) {
        return <DisabledNavItem nav={nav} />;
    }

  const active = isActive(nav.path);

  const handleClick = () => {
    if (nav.cta) trackCtaClicked(nav.cta);
    onItemClick?.();
  };

  return (
    <Link
      to={nav.path}
      onClick={handleClick}
      className={`flex items-center px-3 py-3 transition ${
        active
          ? "rounded-sm border-l-[3px] border-blue-600 bg-blue-50/60 pl-[9px] text-slate-900"
          : "bg-transparent text-slate-700 hover:bg-slate-200/35"
      }`}
    >
      <i
        className={`${nav.icon} me-2 ${active ? "text-slate-700" : "text-slate-500"}`}
        aria-hidden
      />
      <span
        className={`text-[0.79rem] font-medium tracking-wideest ${active ? "text-slate-900" : "text-slate-500"}`}
      >
        {nav.name}
      </span>
      {nav.aiBadge ? <NavAiBadge /> : null}
    </Link>
  );
}

export default function SidebarNavSections({ sections, isActive, onItemClick, className = "" }) {
  return (
    <div className={`flex flex-col gap-4 ${className}`.trim()}>
      {sections.map((section) => (
        <nav key={section.id} aria-label={section.label}>
          <h2 className="mb-1.5 px-2 text-xs font-semibold uppercase tracking-widest text-slate-400">
            {section.label}
          </h2>
          <ul className="flex flex-col gap-0">
            {section.items.map((nav) => (
              <li key={`${section.id}-${nav.name}`}>
                <NavItem nav={nav} isActive={isActive} onItemClick={onItemClick} />
              </li>
            ))}
          </ul>
        </nav>
      ))}
    </div>
  );
}
